module.exports = __webpack_public_path__ + "static/media/custom_benchmark.80db7673.svg";